<script setup lang="ts">
import CPricingCard from './CPricingCard.vue'

interface PricingPlan {
  tariffId?: number
  title: string
  description: string
  featuresTitle: string
  features: string[]
  price: string
  originalPrice?: string | null
  discount?: string | null
  isCurrent?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  currentStatus?: string
  buttonText: string
}

interface Props {
  pricingPlans: PricingPlan[]
}

defineProps<Props>()
const emit = defineEmits<{
  select: [tariffId: number]
}>()
</script>

<template>
  <!-- Pricing Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <CPricingCard
      v-for="plan in pricingPlans"
      :key="plan.tariffId ?? plan.title"
      v-bind="plan"
      @select="emit('select', plan.tariffId!)"
    />
  </div>
</template>
